var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.posts),function(post){return _c('div',{key:post.id},[_c('h3',[_vm._v(_vm._s(post.title))]),_vm._v("\n    "+_vm._s(post.body)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }